import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=014b290c&"
import script from "./post.js?vue&type=script&lang=js&"
export * from "./post.js?vue&type=script&lang=js&"
import style0 from "./post.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports